module.exports = __webpack_public_path__ + "img/person-praying.1ba8de92.svg";